import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query/react';
import storageSession from 'redux-persist/lib/storage/session';
import { persistReducer, persistStore } from 'redux-persist';

import uploadSlice from '@/slices/uploadSlice';
import commonSlice from '@/slices/commonSlice';
import googleApiSlice from '@/slices/googleApiSlice';
import facebookApiSlice from '@/slices/facebookApiSlice';
import tempApiSlice from '@/slices/tempSlice';

const rootReducer = combineReducers({
	upload: uploadSlice,
	common: commonSlice,
	google: googleApiSlice,
	facebook: facebookApiSlice,
	temp: tempApiSlice,
});

const persistConfig = {
	key: 'root',
	storage: storageSession,
	debug: true,
	blacklist: ['temp'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
});

export const persistor = persistStore(store);

setupListeners(store.dispatch);
